import { motion } from "framer-motion";

function AydentifyLogo({ isExpanded }: { isExpanded: boolean }) {
    return (
        <div style={{
            position: 'relative',
            display: 'flex',
            height: '64px',
            alignItems: 'center',
            overflow: 'hidden',
            padding: '16px'
        }}>
            <div style={{ position: 'relative' }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    fontSize: '24px',
                    fontWeight: '900',
                    color: '#000000'
                }}>
                    <span style={{ display: 'inline-block' }}>A</span>
                    <motion.div
                        style={{
                            display: 'inline-flex',
                            overflow: 'hidden'
                        }}
                        initial={false}
                        animate={{
                            width: isExpanded ? "auto" : 0,
                        }}
                        transition={{
                            type: "spring",
                            stiffness: 300,
                            damping: 30,
                        }}
                    >
                        <motion.span
                            style={{
                                display: 'inline-block',
                                whiteSpace: 'nowrap'
                            }}
                            initial={{ x: "-100%" }}
                            animate={{ x: isExpanded ? 0 : "-100%" }}
                            transition={{
                                type: "spring",
                                stiffness: 300,
                                damping: 30,
                            }}
                        >
                            YDENTIFY
                        </motion.span>
                    </motion.div>
                </div>

                {/* Animated underline that extends with the text */}
                <motion.div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        height: '1px',
                        backgroundColor: 'black'
                    }}
                    initial={{ width: 10 }}
                    animate={{
                        width: isExpanded ? "100%" : 10,
                    }}
                    transition={{
                        type: "spring",
                        stiffness: 300,
                        damping: 30,
                    }}
                />
            </div>
        </div>
    )
}

export default AydentifyLogo;